import { useEffect, useSyncExternalStore, type ReactNode } from "react"

type ThreadHeaderAction = (state: { disabled: boolean }) => ReactNode

// The route supplies workspace-scoped actions without an app-covi import cycle.
let accessory: ThreadHeaderAction | null = null
const listeners = new Set<() => void>()

function emit(): void {
  for (const listener of listeners) {
    listener()
  }
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = (): ThreadHeaderAction | null => accessory
const getServerSnapshot = (): ThreadHeaderAction | null => null

export function useSofiaThreadHeaderAction(): ThreadHeaderAction | null {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

export function useSetSofiaThreadHeaderAction(
  node: ThreadHeaderAction | null,
): void {
  useEffect(() => {
    accessory = node
    emit()
    return () => {
      if (accessory === node) {
        accessory = null
        emit()
      }
    }
  }, [node])
}
